// extracted by mini-css-extract-plugin
export default {"video-link":"m_bm d-flex align-items-center my-2","video-link__link":"m_bn ml-2"};